var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.savedSearches),function(search){return _c('li',{key:search.saved_search_id},[_c('a',{attrs:{"href":search.redirect_url}},[_vm._v(" "+_vm._s(search.label)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }